<template>
  <div class="containerBox">
    <div class="content">
      <div class="lf">
        <div
          class="item wow animate__animated durationTime animate__bounceInLeft"
          v-for="item in list1"
          :key="item.name"
          :style="{
            backgroundImage: `url(${require(`@/assets/${item.imgSrc}`)})`
          }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="center">
        <img
          src="@/assets/image/xplan/trusteeshipText.png"
          class=" wow animate__animated durationTime animate__swing"
          alt=""
        />
        <div style="display: flex;justify-content: center;">
          <div class="img-con-x-third wow animate__animated durationTime animate__fadeInUp">
            <router-link class="img-con-x-third-text" to="/trusteeship">
              <div style="display: flex;align-items: center;">
                <div style="margin-right: 0.14rem">了解更多</div>
                <div>>></div>
              </div>
            </router-link>
          </div>
        </div>

      </div>

      <div class="rg">
        <div
          class="item wow animate__animated durationTime animate__bounceInRight"
          v-for="item in list2"
          :key="item.name"
          :style="{
            backgroundImage: `url(${require(`@/assets/${item.imgSrc}`)})`
          }"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {
      list1: [
        {
          name: "免人工管理",
          imgSrc: "image/xplan/trusteeship1.png"
        },
        {
          name: "总部全程扶持",
          imgSrc: "image/xplan/trusteeship2.png"
        },
        {
          name: "省时省心省力",
          imgSrc: "image/xplan/trusteeship3.png"
        }
      ],
      list2: [
        {
          name: "低投入高回报",
          imgSrc: "image/xplan/trusteeship4.png"
        },
        {
          name: "新手也能操作",
          imgSrc: "image/xplan/trusteeship5.png"
        },
        {
          name: "7*24小时客服",
          imgSrc: "image/xplan/trusteeship6.png"
        }
      ]
    };
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.img-con-x-third {
  margin-top: 0.4rem;
  font-weight: bold;
  width: 1.8rem;
  height: 0.6rem;
  background: #fef100;
  opacity: 1;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-con-x-third-text {
  font-size: 0.16rem;
  //font-weight: 400;
  line-height: 0.3rem;
  color: #3b5377;
  opacity: 1;
}
.containerBox {
  width: 100%;
  padding: 2.8rem 0;
  background: url(../../../assets/image/xplan/trusteeshipBg.png) center
    no-repeat;
  background-size: cover;
  background-color: #510203;
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      width: 4.89rem;
      height: 1.22rem;
      background-position: right center;
      background-repeat: no-repeat;
      background-size: auto 100%;
      line-height: 1.22rem;
      font-size: 0.34rem;
      color: #fff;
      margin-bottom: 0.8rem;
      &:nth-child(3) {
        margin-bottom: 0;
      }
    }
    .lf {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .item {
        text-align: right;
        padding-right: 1.6rem;

        &:nth-child(2) {
          margin-right: 0.63rem;
        }
      }
    }
    .rg {
      .item {
        background-position: left center;
        padding-left: 1.5rem;
        &:nth-child(2) {
          margin-left: 0.69rem;
        }
      }
    }
    .center {
      width: 4.59rem;
      height: 2.32rem;
      margin: 0 0.36rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xplan/components/trusteeship.vue